module.exports = __webpack_public_path__ + "img/handoffIcon_2.1f195560.svg";